import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedService } from '../../services/feed.service';
import { ToastService } from 'src/app/core/toast.service';
import { DeletePopupComponent } from 'src/app/modules/dashboard/delete-popup/delete-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { PostnewJob } from 'src/app/modules/profile/services/job-section.service';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { Tables } from 'src/app/shared/enum/tables.enum';
@Component({
  selector: 'app-list-job-role',
  templateUrl: './list-job-role.component.html',
  styleUrls: ['./list-job-role.component.scss']
})
export class ListJobRoleComponent implements OnInit {
  displayedColumns: string[] = ['sNo', 'role_name', 'created_at', 'updated_at', 'action'];
  dataSource: MatTableDataSource<any>;
  selection = new SelectionModel<any>(true, []);
  totalElements: number = 0;
  offset = { value: 0 };
  limit = { value: 10 };
  role: any[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(private router: Router,
    private route: ActivatedRoute, public feedService: FeedService, private toast: ToastService, private dialog: MatDialog, private jobService: PostnewJob , private commonService:CommonServicesForAllModules) {
  }

  ngOnInit(): void {
    this.getRoles();
    
  }

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }
  

  editRoles(role: any) {
    if (role.id) {
      this.router.navigate(['profile', 'job-role-listing-role', 'edit', role.id], {
        queryParams: { roleName: role.role_name }
      });
    }
  }

  getRoles() {
    this.jobService.getJobsRoleMain().subscribe(data => {
      if (Array.isArray(data)) {
        this.role = [
          ...data
        ];
      } else {
        console.error("Expected an array but received:", data);
      }
    }, error => {
      console.error("Error fetching categories:", error);
      
    });
  }

  deleteRoles(role: any): void {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '600px',
      data: {
        item: role,
        name: 'Role'
      },
    });

    dialogRef.afterClosed().subscribe(async (response) => {
      if (response === 'yes' && role?.id) {
        try {
          await this.commonService.DeleteById(Tables.Jobs_Role_List, role.id);
          this.toast.openSnackBar('Role deleted successfully');
          this.getRoles();
        } catch (err) {
          console.error('Failed to delete role:', err);
          this.toast.openSnackBar('Failed to delete role');
        }
      }
    });
  }


  addJobRole(): void {
    this.router.navigate(['../add-job-role'], { relativeTo: this.route });
  }
}